import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * List View Icon
 *
 * @file ListView.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const ListView = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <rect x="3" y="6" width="18" height="4" rx="1" stroke="currentcolor" strokeWidth="1.5" />
      <rect x="3" y="14" width="18" height="4" rx="1" stroke="currentcolor" strokeWidth="1.5" />
    </g>
  </SvgIcon>
);

export default ListView;
